import { queryClient } from '@vlabs/api';
import {
  extractAttributes, getGetFaceQueryOptions, patchFace, putFaceAttributes,
} from '@vlabs/api/luna-api/client';

export async function changeFacePhotoAndAttribute(
  faceId: string,
  sampleId: string,
): Promise<void> {
  const extractedAttributes = await extractAttributes([sampleId], { extract_basic_attributes: 1 });
  const attributeId = extractedAttributes?.[0]?.attribute_id;
  if (!attributeId) return;

  await Promise.all([
    putFaceAttributes(faceId, {
      attribute_id: attributeId,
    }),
    patchFace(faceId, {
      avatar: `/6/samples/faces/${sampleId}`,
    }),
  ]);
  queryClient.invalidateQueries(getGetFaceQueryOptions(faceId));
}
